// Invitations and members (DEC-140, SDD §38.4). Admin only.

import { http } from './client'

export type MemberStatus = 'invited' | 'active' | 'disabled'
export type InvitationState = 'pending' | 'accepted' | 'expired' | 'revoked'

export interface InviteResult {
  link_id: string
  email: string
  profile: string
  expires_at: string
  /**
   * Returned by the API so an operator can send the link by hand (DEC-140).
   * This is what keeps a demo off Amazon SES's critical path: a new SES account
   * is sandboxed until AWS grants production access.
   */
  invite_url: string
  email_sent: boolean
  email_notice: string | null
  /** DEC-142: advisory only, never a block. */
  domain_notice: string | null
}

export interface InvitationSummary {
  link_id: string
  email: string
  profile: string | null
  state: InvitationState
  created_at: string
  expires_at: string
}

export interface MemberSummary {
  user_id: string
  email: string | null
  name: string | null
  profile: string
  status: MemberStatus
  last_login_at: string | null
  /** §38.7: set on a legacy row that has no address and cannot be sent a link. */
  notice: string | null
}

export interface DisableResult {
  user_id: string
  status: string
  sessions_revoked: number
  invitations_revoked: number
}

export const membersApi = {
  invite: (email: string, profile: string, name?: string) =>
    http.post<InviteResult>('/api/v1/invitations', { email, profile, name: name || null }),

  listInvitations: () =>
    http.get<{ invitations: InvitationSummary[] }>('/api/v1/invitations'),

  revokeInvitation: (linkId: string) =>
    http.delete<void>(`/api/v1/invitations/${linkId}`),

  listMembers: () => http.get<{ members: MemberSummary[] }>('/api/v1/members'),

  disable: (userId: string) =>
    http.post<DisableResult>(`/api/v1/members/${userId}/disable`, {}),
}
